import { LOCAL_STORAGE_PLACEMENT_ID } from "../../helpers/consts";
import { useRecoilState } from "recoil";
import {
  getSelectedPlacement,
  selectedPlacementAtom,
} from "../../atoms/selectedPlacementAtom";
import { useState } from "react";
import styles from "./EditMapPlacements.module.css";
import Sprite from "../object-graphics/Sprite";
import {
  CATEGORIES,
  placementSelectionOptions,
} from "../../atoms/selectedPlacementAtom";

export default function EditMapPlacements() {
  const [selectedPlacementId, setSelectedPlacementId] = useRecoilState(
    selectedPlacementAtom
  );
  const initialCategory =
    getSelectedPlacement(selectedPlacementId).category ?? CATEGORIES.BASICS;
  const [category, setCategory] = useState(initialCategory);

  return (
    <>
      <label>
        <span className="label-text">OBJECT CATEGORY</span>

        <select
          className={styles.categorySelect}
          value={category}
          onChange={(e) => {
            setCategory(e.target.value);
          }}
        >
          {Object.keys(CATEGORIES).map((key) => {
            return (
              <option key={key} value={CATEGORIES[key]}>
                {CATEGORIES[key]}
              </option>
            );
          })}
        </select>
      </label>
      <div className={styles.tilesGrid}>
        {placementSelectionOptions
          .filter((optionData) => {
            return optionData.category === category;
          })
          .map((optionData) => {
            return (
              <button
                data-active={optionData.id === selectedPlacementId}
                key={optionData.id}
                onClick={() => {
                  setSelectedPlacementId(optionData.id);
                  window.localStorage.setItem(
                    LOCAL_STORAGE_PLACEMENT_ID,
                    optionData.id
                  );
                }}
              >
                <span className={styles.scaledContainer}>
                  <Sprite frameCoord={optionData.preview} />
                </span>
              </button>
            );
          })}
      </div>
    </>
  );
}
